import Link from 'next/link';

export default function Custom404() {
    return (
        <div className="flex flex-col items-center justify-center h-[50vh] p-5">
            <h1 dir="ltr"  className="text-4xl font-bold text-center">Are you Sure you&rsquo;re in the right place ?</h1>
            <Link href="/">
                <button className="mt-4 px-4 py-2 bg-primary text-white rounded-lg cursor">Go Home</button>
            </Link>
        </div>
    );
}